import i18n from '@shared/i18n';

// Fork from @shared/services/src/cookie/constants.ts
// turbopack 在 nextjs 15.3.1 在 server side 獲取 monorepo 的 package 會有編譯問題
// 所以先複製一份到這邊專門給 server side proxy 使用
export const FORK_FROM_SHARED_COOKIE_KEY_MAP = {
    beacon: 'general.koi.shop.service.user.beacon', // Beacon
    brandId: 'merchant.koi.shop.service.brand.id',
    uid: 'merchant.koi.shop.service.login.user.id',
    refreshToken: 'merchant.koi.shop.service.rtk',
    accessToken: 'merchant.koi.shop.service.atk',
    memberUid: 'member.koi.shop.service.login.user.id',
    memberRefreshToken: 'member.koi.shop.service.rtk',
    memberAccessToken: 'member.koi.shop.service.atk',
};

export const CUSTOM_EVENT = {
    SECTION_POSITIVE_BUTTON_HACKING_EVENT: 'dispatch_panel_change_application',
    SECTION_NEGATIVE_BUTTON_HACKING_EVENT: 'abort_panel_change_application',
    ADD_NEW_CAROUSEL_SLIDE_EVENT: 'add-new-carousel-slide',

    // @shared/services/createRequest.ts 也有使用
    LOGIN_TOKEN_EXPIRED_EVENT: 'login-token-expired',
    PERMISSION_INSUFFICIENT_EVENT: 'permission-insufficient',
} as const;

export const CACHE_QUERY_KEY = {
    product: 'get/product',
    productCountByStatus: 'get/product/count-by-status',
    category: 'get/product/category',
    descriptionTemplate: 'get/product/description-template',
    descriptionTemplateById: 'get/product/description-template',
    calculate: 'post/calculate',
    giveaway: 'promo/giveaway',
    promo: 'promo/promo',
    coupon: 'promo/coupon',
    order: 'get/order',
    orderGiveaway: 'get/promo/order-giveaway',
    shippingProfile: 'get/shipping/profile',
    cartShippingMethod: 'get/cart/shipping-method',
    memberProfile: 'get/member',
    brandMember: 'get/brand/member',
    componentMenu: 'get/component/menu',
    planBindCard: 'get/plan/bind-card',
    buyerProduct: 'buyer/get/product',
    buyerProductShippingMethod: 'buyer/get/product/shipping-method',
    buyerProductAddressCountry: 'buyer/get/product/address-country',
    buyerProductPromoProductGiveaway: 'buyer/get/product/promo/product-giveaway',
    buyerCartCount: 'buyer/get/cart/count',
    brandFinancialReport: 'get/brand/financial-report',
    brandProgress: 'get/brand/setting/progress',
    brand: 'get/brand',
    merchantProfile: 'get/merchant/profile',
    plan: 'get/plan',
    page: 'get/page',
    brandSystemMessage: 'get/brand/system-message',
    kycFinancialSetting: 'get/kyc/financial-setting',
};

export enum SHIPPING_TYPE {
    STANDARD = 'standard',
    EXPRESS = 'express',
    REFRIGERATED = 'refrigerated',
    FROZEN = 'frozen',
    SEVEN_COD = 'seven_cod',
    SEVEN_C2C = 'seven_c2c',
}

export const SHIPPING_TYPE_NAME_MAP: Record<string, string> = {
    [SHIPPING_TYPE.STANDARD]: i18n.gettext('基本運送（一般宅配）'),
    [SHIPPING_TYPE.EXPRESS]: i18n.gettext('快捷運送'),
    [SHIPPING_TYPE.REFRIGERATED]: i18n.gettext('冷藏運送'),
    [SHIPPING_TYPE.FROZEN]: i18n.gettext('冷凍運送'),
    [SHIPPING_TYPE.SEVEN_COD]: i18n.gettext('7-11 取貨付款'),
    [SHIPPING_TYPE.SEVEN_C2C]: i18n.gettext('7-11 取貨不付款（店到店）'),
} as const;

export enum CUSTOM_SHOP_PAGE_KEY {
    HOME = 'home',
    PRODUCT = 'product',
    ABOUT = 'about',
    CUSTOM = 'custom',
}

export const requiredCustomPageKeys = [
    CUSTOM_SHOP_PAGE_KEY.HOME,
    CUSTOM_SHOP_PAGE_KEY.PRODUCT,
] as const;

export const createCustomPagePayloadMap = {
    [CUSTOM_SHOP_PAGE_KEY.HOME]: {
        name: CUSTOM_SHOP_PAGE_KEY.HOME,
        custom_name: i18n.gettext('首頁'),
        segment: CUSTOM_SHOP_PAGE_KEY.HOME,
    },
    [CUSTOM_SHOP_PAGE_KEY.PRODUCT]: {
        name: CUSTOM_SHOP_PAGE_KEY.PRODUCT,
        custom_name: i18n.gettext('商品頁'),
        segment: CUSTOM_SHOP_PAGE_KEY.PRODUCT,
    },
    [CUSTOM_SHOP_PAGE_KEY.CUSTOM]: {
        name: CUSTOM_SHOP_PAGE_KEY.CUSTOM,
        custom_name: i18n.gettext('自訂頁面'),
    },
    [CUSTOM_SHOP_PAGE_KEY.ABOUT]: {
        name: CUSTOM_SHOP_PAGE_KEY.CUSTOM,
        custom_name: i18n.gettext('關於我'),
        segment: CUSTOM_SHOP_PAGE_KEY.ABOUT,
    },
} as const;

export const MIGRATION_TOKEN_KEY = 'token';

export const MIGRATING_KEY = 'migrating';

export const TUTORIAL_KEY = 'hellopinzap';
